<template>
  <div class="info-container">
    <index-modal ref="modalFilter" @setFilter="setFilterTag"></index-modal>
    <div>
      <div class="info-label">Status</div>
      <div class="info-content">
        <info-check-in-status v-model="status" :set-async="checkTag"/>
      </div>
    </div>
    <div>
      <div class="info-label">Atividades recentes</div>
      <div class="info-content">
        <info-check-in-activities-list :list="activitiesList"/>
      </div>
    </div>
    <div v-if="leadActive">
      <div class="info-label">Coleta de Lead</div>
      <div class="info-content">
        <info-check-in-lead-form :form="leadForm" />
      </div>
    </div>
    <div v-if="!leadActive">
      <div class="info-label">Observação</div>
      <div class="info-content">
        <info-check-in-comment />
      </div>
    </div>
  </div>
</template>

<script>
import InfoCheckInActivitiesList from '@/modules/check-in/pages/info/info-check-in/info-check-in-activities-list'
import InfoCheckInStatus, { AVAILABLE_STATUS } from '@/modules/check-in/pages/info/info-check-in/info-check-in-status'
import IndexModal from '@/modules/check-in/pages/index/index-modal'
import { CHECK_IN_MODULE } from '@/modules/check-in'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { putManualCheckIn } from '@/modules/check-in/service/putManualCheckIn'
import { putManualCheckOut } from '@/modules/check-in/service/putManualCheckOut'
import { putManualUnseen } from '@/modules/check-in/service/putManualUnseen'
import { fetchTags } from '@/modules/check-in/service/fetchTags'
import { mapMutations } from 'vuex'
import InfoCheckInComment from '@/modules/check-in/pages/info/info-check-in/info-check-in-comment'
import InfoCheckInLeadForm from '@/modules/check-in/pages/info/info-check-in/info-check-in-lead-form'
import { fetchLeadForm } from '@/modules/check-in/service/leadForm'

export default {
  name: 'info-check-in',
  components: { InfoCheckInComment, InfoCheckInLeadForm, InfoCheckInStatus, InfoCheckInActivitiesList, IndexModal },
  data: () => ({
    status: null,
    rawCommentList: [],
    filterTags: [],
    statusCheck: null,
    prevStatus: null,
    leadForm: null
  }),
  computed: {
    tagsList () {
      return this.$store.state[CHECK_IN_MODULE].tags.list
    },
    currentId () {
      return this.$store.state[CHECK_IN_MODULE].showDetailId
    },
    item () {
      return this.$store.getters[CHECK_IN_MODULE + '/detailById'](this.currentId)
    },
    activitiesList () {
      const item = this.item
      if (item) {
        this.updateStatus(item.isStatusCheckIn, item.isStatusCheckOut)
        return item.activitiesList
      }
      return []
    },
    // Formulário de lead ativo (com campos) — quando ativo, substitui a Observação
    leadActive () {
      return !!(this.leadForm && this.leadForm.status === true &&
        Array.isArray(this.leadForm.fields) && this.leadForm.fields.length > 0)
    }
  },
  mounted () {
    fetchLeadForm()
      .then(data => { this.leadForm = data })
      .catch(() => { this.leadForm = null })
  },
  methods: {
    ...mapMutations(CHECK_IN_MODULE, ['updateItemStatus']),
    async checkTag (status, prevStatus) {
      if (this.tagsList.length === 0) {
        await this.changeStatus(status, prevStatus)
        return
      }
      this.statusCheck = status
      this.prevStatus = prevStatus
      await this.$refs.modalFilter.open()
    },
    setFilterTag (filter) {
      this.filterTags = filter
      if (this.statusCheck) {
        this.changeStatus(this.statusCheck, this.prevStatus)
      }
    },
    updateStatus (isStatusCheckIn, isStatusCheckOut) {
      if (isStatusCheckIn) {
        this.status = AVAILABLE_STATUS.CHECK_IN
      } else if (isStatusCheckOut) {
        this.status = AVAILABLE_STATUS.CHECK_OUT
      } else {
        this.status = AVAILABLE_STATUS.AGUARDANDO
      }
    },
    async fetchListTags () {
      try {
        const response = await fetchTags()
        // this.$store.commit(CHECK_IN_MODULE + '/updateTags', { tags: response })
        this.tagsList.push(...response)
      } catch ({ serverMessage }) {
        errorMessage(serverMessage ?? 'Ocorreu algum erro ao realizar essa ação.')
      }
    },
    async changeStatus (status, prevStatus) {
      let action = putManualUnseen
      if (status === AVAILABLE_STATUS.CHECK_IN) {
        action = putManualCheckIn
      } else if (status === AVAILABLE_STATUS.CHECK_OUT) {
        action = putManualCheckOut
      }
      try {
        const { message, ok, detail } = await action(this.currentId, [this.filterTags.tag])
        if (!ok) {
          const exc = { serverMessage: message }
          throw exc
        } else {
          successMessage(message ?? 'Ação realizada com sucesso.')
          this.updateItemStatus({
            id: this.currentId,
            isStatusCheckIn: status === AVAILABLE_STATUS.CHECK_IN,
            isStatusCheckOut: status === AVAILABLE_STATUS.CHECK_OUT,
            isStatusUnseen: status === AVAILABLE_STATUS.AGUARDANDO,
            userLoggedInName: this.$store.state.auth?.user?.name,
            details: detail || ''
          })
        }
      } catch ({ serverMessage }) {
        errorMessage(serverMessage ?? 'Ocorreu algum erro ao realizar essa ação.')
        this.status = prevStatus
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  .info-label {
    font-weight: 500;
    font-size: 14px;
    color: #000;
    margin-bottom: 14px;
  }

  .info-content {
    margin-bottom: 34px;
  }
}
</style>
